<script setup>
import {useRoute} from "vue-router";
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {game} from "@/utils/config";
import CopyRightComponents from "@/components/system/CopyRightComponents.vue";
import LoginComponents from "@/components/login/LoginComponents.vue";
import {Base64} from "js-base64";
import axiosApi, {$_ajax} from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import router from "@/router";

const type = computed(() => {
  let _type = store.state.coupon
  if (_type) {
    const _d = game[_type]
    document.title = _d.title
    return _d
  }
  return {}
})
const recharge_step = ref(0)
const account = computed(() => {
  return store.state.account
})
const success = ref(false)
const changeProduct = ref(false)
const showLogin = ref(false)
const route = useRoute()
const productLst = ref([])
const product = ref({})
const rechargeAccount = ref("")
const showSend = ref(false)
const realDialog = ref(false)
const payLoading = ref(false)
onMounted(() => {
  if (route.query.customerId) {
    //处理单点登录
    $_ajax.get(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: route.query}).then(({data}) => {
      if (Object.keys(data.data).length) {
        data.data.phoneNumber = /^1[2-9]\d{9}/.test(data.data.phoneNumber) ? data.data.phoneNumber : Base64.decode(data.data.phoneNumber)
        store.dispatch("setAccounts", data.data)
      }
    })
  }
  if (route.query.type) {
    store.commit("setCoupon", route.query.type)
  } else {
    store.commit("getCoupon")
  }
  store.dispatch("getAccounts")
  getProduct()
})
const loginCall = () => {
  showLogin.value = false
  if (Object.keys(account.value).length < 1) return;
  if (Object.keys(product.value).length) {
    if (account.value.balance_miles < parseInt(product.value.mileTypes.scal.total)) {
      return ElMessage.error("您的里程不足");
    }
    changeProduct.value = true
  }
}
const getProduct = () => {
  // if(!type.value.isIos) {
  //   return ElMessage.error({
  //     message: `${type.value.name}仅支持IOS端兑换充值`
  //   })
  // }
  new axiosApi({
    method: "life/goodsLst",
    encode: "coupon",
    body: {
      type: type.value.coupon,
      child: type.value.plate
    }
  }).send((res) => {
    if (res.message.code !== "000") return ElMessage.error(res.message.content)
    productLst.value = res.data.map(its => {
      its.remarks = its.remarks ? JSON.parse(its.remarks) : {}
      return its
    })
  })
}
const productLogin = pro => {
  product.value = pro
  showLogin.value = true
}
const productChecked = pro => {
  product.value = pro
  changeProduct.value = true
}
const pay = () => {
  if (rechargeAccount.value === "" || !rechargeAccount.value || rechargeAccount.value.length < 1) {
    return ElMessage.error("请输入充值账号")
  }
  if (!showSend.value) {
    showSend.value = true
    return
  }
  showSend.value = false
  payLoading.value = true
  new axiosApi({
    encode: "coupon",
    method: "line/gamePay",
    body: {
      plate: type.value.coupon,
      product: product.value.third_id,
      type: "scal",
      cust_id: account.value.cust_id,
      account: rechargeAccount.value,
      access_token: account.value.access_token || "",
      user_id: account.value.user_id || ""
    }
  }).send(res => {
    payLoading.value = false
    if (res.message.code !== "000" && res.message.code !== '7401') return ElMessage.error(res.message.content)
    else if (res.message.code === '7401') {
      realDialog.value = true
      return
    }
    success.value = true
    changeProduct.value = false
    product.value = {}
  }, () => payLoading.value = false)
}
const orderLst = () => {
  router.push({name: "order"})
}
</script>

<template>
  <!--  <div></div>-->
  <el-scrollbar class="page-pid page-home" :class="type.plate" :style="type.style">
    <div class="banner">
      <el-image :src="type.banner" style="width: 100%"/>
    </div>
    <div class="user-accounts">
      <div class="user-login-items">
        <div class="user-jingle">
          <el-image :src="type.icon" class="user-brand-icon"/>
          {{ type.jingle }}
        </div>
        <div class="user-login-btn">
          <div class="user-login-btn-exchange" @click="orderLst">
            <i class="ticket-font ticket-dingdan6"></i>兑换记录
          </div>
          <div class="user-login-btn-exchange" v-if="Object.keys(account).length"
               @click="store.commit('removeAccount')">
            <i class="ticket-font ticket-logout"></i>退出登录
          </div>
        </div>
      </div>
      <div class="login-query">
        <el-input placeholder="请输入川航金熊猫会员手机号" v-model="account.mobile" disabled>
          <template #prefix>
            <el-icon size="25" color="#DD0000">
              <Search/>
            </el-icon>
          </template>
          <template #suffix>
            <el-button type="danger" link v-if="Object.keys(account).length < 1" @click="showLogin=true">查询可用里程
            </el-button>
            <el-button type="danger" link v-else>可用里程：{{ account.balance_miles }}</el-button>
          </template>
        </el-input>
      </div>
    </div>
    <div class="product-lst">
      <div class="product-header">{{ type.name }}</div>
      <el-row :gutter="10" class="product-lst-items">
        <el-col :span="12" v-for="i in productLst" :key="i.thrid_id">
          <div class="product-lst-info">
            <div class="product-img">
              <el-image :src="type.productImg"/>
              <div class="product-values">
                <b>{{ i.remarks.number }}</b>{{ type.unit }}
              </div>
            </div>
            <div class="product-money">
              <div class="product-money-value">
                <b style="font-size: 1.45rem">{{ i.mileTypes.scal.total }}</b>里程
              </div>
              <div v-if="type.isIos">
                <el-button type="danger" round v-if="Object.keys(account).length < 1"
                           @click="productLogin(i)">
                  立即兑换
                </el-button>
                <el-button type="danger" round
                           v-else-if="Object.keys(account).length && parseInt(account.balance_miles) >= parseInt(i.mileTypes.scal.total)"
                           @click="productChecked(i)">
                  立即兑换
                </el-button>
                <el-button type="info" round v-else>可用里程不足</el-button>
              </div>
              <el-button type="info" round style="font-size: .6rem" v-else>{{ type.sysTips }}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="recharge-step-items">
      <div class="recharge-step-items-tabs"
           :style="{'background-image':`url('${type.recharge_tabs_img[recharge_step]}')`}"
           v-if="type.recharge_tabs_img">
        <div class="step-tabs" @click="recharge_step=0"></div>
        <div class="step-tabs" @click="recharge_step=1"></div>
      </div>
      <div class="recharge-step-items-contents">
        <div v-if="recharge_step===0">
          <div v-for="(text,inx) in type.rechargeText" :key="inx">
            <h4 v-if="text.name.length">{{ text.name }}：</h4>
            <ol class="recharge-contents">
              <li v-for="(content,i) in text.titles" :key="i" v-html="content"></li>
            </ol>
          </div>
        </div>
        <div class="recharge-img-lst" v-if="recharge_step === 1">
          <el-image :src="type.recharge_image_content"/>
        </div>
      </div>
    </div>
    <copy-right-components/>
  </el-scrollbar>
  <el-dialog v-model="success" :show-close="false" width="90%" class="success-dialog" style="border-radius: 12px"
             v-if="success" :style="type.style">
    <div class="success-image">
      <el-image :src="type.successImg"/>
      <div class="success-content">兑换成功</div>
    </div>
    <div class="success-btn">
      <div class="cancel-btn bts" @click="success=false">返回首页</div>
      <div class="order-btn bts" @click="orderLst">查看订单</div>
    </div>
  </el-dialog>
  <el-drawer v-model="changeProduct" direction="btt" style="border-radius: 12px 12px 0 0" size="420"
             :show-close="false" v-if="changeProduct" :style="type.style">
    <template #header>
      <div class="product-info-header">
        <div class="product-img product-info-img">
          <el-image :src="type.productImgAvatar"/>
          <div class="product-values">
            <b>{{ product.remarks.number }}</b>{{ type.unit }}
          </div>
        </div>
        <div class="product-info-data">
          <h3>【{{ type.name }}】{{ product.remarks.number }}{{ type.unit }}</h3>
          <div class="product-info-money">
            <b>{{ product.mileTypes.scal.total }}</b>里程
            <div class="tips">请检查输入的{{ type.tips }}是否正确</div>
          </div>
        </div>
      </div>
    </template>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-data">
        <div class="user-account-data-title">
          {{ type.input_tag }}
        </div>
        <div class="input">
          <el-input :placeholder="`请输入${type.tips}`" clearable class="product-input"
                    v-model="rechargeAccount"/>
        </div>
      </div>
    </el-card>
    <el-card style="margin-bottom: 20px">
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          可用里程
        </div>
        <div class="miles">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="user-account-miles">
        <div class="user-account-data-jingle">
          支付里程
        </div>
        <div class="miles">
          {{ product.mileTypes.scal.total }}
        </div>
      </div>
    </el-card>
    <div class="product-recharge-btn">
      <el-button type="danger" round size="large"
                 :disabled="parseInt(product.mileTypes.scal.total) > account.balance_miles || !type.isIos"
                 :loading="payLoading"
                 @click="pay">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <login-components :show-login="showLogin" @login="loginCall" v-if="showLogin"/>
  <send-sms-components :show="showSend" @sends="pay" :login-account="account" v-if="showSend"/>
  <real-name :dialog="realDialog" @changeModel="realDialog=false" v-if="realDialog"/>
</template>

<style scoped lang="less">
.page-home {
  height: 100vh;
  box-sizing: border-box;
  background-color: var(--view-background-color);

  .copyright {
    color: var(--view-copy-right-color) !important;
  }

  .recharge-img-lst {
    background: var(--view-recharg-background-color);
    padding: 10px;
    border-radius: 12px;
  }

  .product-header {
    position: absolute;
    top: -18px;
    z-index: 999;
    left: 0;
    right: 0;
    height: 45px;
    text-align: center;
    line-height: 45px;
    font-size: 1.33rem;
    color: #ffffff;
    font-weight: 600;
  }

  .product-lst-items {
    margin-top: 25px;

    .product-lst-info {
      border-color: var(--view-product-lst-border-color) !important;


      .product-money {
        text-align: center;
        padding: 15px 0;

        .product-money-value {
          margin-bottom: 10px;
        }

        .el-button {
          width: 90%;
        }
      }
    }
  }

  &.dzpd {
    .product-header {
      background: url("@/assets/images/dzpd/product-title.png") no-repeat center;
      background-size: 180px auto;
    }
  }

  &.qyjsq {
    .product-header {
      background: url("@/assets/images/qyjsq/product-title.png") no-repeat center;
      background-size: 180px auto;
    }

    .product-values {
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
    }
  }

  .banner {
    padding: 10px;
  }

  .user-accounts {
    margin-bottom: 15px;

    .user-login-items {
      padding-left: 10px;
      display: flex;
      justify-content: space-between;
      align-items: start;

      .user-jingle {
        display: flex;
        align-items: center;
        font-size: .85rem;

        .user-brand-icon {
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }

      .user-login-btn {
        .user-login-btn-exchange {
          background: #ffffff;
          line-height: 2;
          border-radius: 45px 0 0 45px;
          margin-bottom: 5px;
          padding-left: 25px;
          padding-right: 15px;
          color: var(--view-exchange-color);
        }
      }
    }

    .login-query {
      padding: 10px;

      .el-input {
        height: 45px;
      }
    }
  }

  .product-lst {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: var(--el-box-shadow);
    padding: 10px;
    border-radius: 12px;
    position: relative;

    .product-lst-items {
      .product-lst-info {
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 10px;
        border: 2px solid;
        border-radius: 8px;
      }
    }
  }

  .recharge-step-items {
    margin: 15px;
    box-sizing: border-box;

    .recharge-step-items-tabs {
      //background: url('@/assets/images/dzpd/recharge.png') no-repeat;
      background-repeat: no-repeat;
      height: 60px;
      background-size: 100%;
      display: flex;

      .step-tabs {
        flex-basis: 50%;
        height: 60px;
        width: 50%;
        //background: #E31D1A;
      }
    }

    .recharge-step-items-contents {
      background: #ffffff;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 0 0 12px 12px;
      margin-top: -10px;

      .recharge-contents {
        padding-left: 18px;
        line-height: 25px;
        font-size: .85rem;
      }
    }
  }
}

.success-dialog {
  .success-image {
    margin: 15px auto;
    width: 140px;
    text-align: center;

    .success-content {
      margin-top: 10px;
      font-size: 1.25rem;
      font-weight: 600;
      color: var(--view-product-success-color);
    }
  }

  .success-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    .bts {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;

      &.order-btn {
        margin-left: 10px;
        background: var(--view-product-success-btn-success-background);
        color: var(--view-product-success-btn-success-color);
      }

      &.cancel-btn {
        background: var(--view-product-success-btn-cancel-background);
        color: var(--view-product-success-btn-cancel-color);
      }
    }
  }
}

.product-info-header {
  display: flex;
  align-items: start;


  .product-info-data {
    margin-left: 10px;
    line-height: 25px;

    .product-info-money {
      margin-top: 10px;

      b {
        font-size: 1.75rem;
        color: #E31D1A;
      }

      .tips {
        font-size: .65rem;
        color: #FF8409
      }
    }
  }
}

.user-account-data {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .user-account-data-title {
    font-size: .8rem;
    color: var(--view-product-user-pay-account-tips);
    border: var(--view-product-user-pay-account-tips-border);
    padding: 5px;
    border-radius: 3px;
  }

  .input {
    width: 72%;
    flex-basis: 72%;
  }
}

.user-account-miles {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 35px;

  & + .user-account-miles {
    border-top: var(--el-border);
  }
}

.product-recharge-btn {
  width: 220px;
  margin: auto;

  .el-button {
    width: 100%;

  }
}

.product-img {
  position: relative;

  .product-values {
    position: absolute;
    bottom: 10px;
    left: 5px;
    background: var(--view-product-value-background-color);
    text-align: center;
    line-height: 1.75;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 45px;
    color: var(--view-product-value-color);
    white-space: nowrap;
  }

  &.product-info-img {
    width: 110px;

    .product-values {
      font-size: .75rem;
    }
  }
}
</style>
